import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  HiOutlineUsers, HiOutlineSparkles, HiOutlineRefresh,
  HiOutlineLocationMarker, HiOutlineSwitchHorizontal,
} from 'react-icons/hi';

// Tab bar shown at the top of every page inside the Leads section.
// Smart Lists, Re-engagement, Territories and Auto-Assign Rules live
// directly inside the Leads section as tabs.
const TABS = [
  { to: '/app/leads', label: 'Leads', icon: HiOutlineUsers, exact: true },
  { to: '/app/leads/segments', label: 'Smart Lists', icon: HiOutlineSparkles },
  // Re-engagement tab commented out (hidden from the Leads section, not removed).
  // To re-enable, uncomment the line below.
  // { to: '/app/leads/re-engagement', label: 'Re-engagement', icon: HiOutlineRefresh },
  { to: '/app/leads/territories', label: 'Territories', icon: HiOutlineLocationMarker },
  { to: '/app/leads/assignment-rules', label: 'Auto-Assign Rules', icon: HiOutlineSwitchHorizontal },
];

const LeadsTabs = () => (
  <div className="flex gap-1 overflow-x-auto border-b border-gray-200 -mx-1 px-1">
    {TABS.map((tab) => (
      <NavLink
        key={tab.to}
        to={tab.to}
        end={tab.exact === true}
        className={({ isActive }) =>
          `flex items-center gap-1.5 px-3 sm:px-4 py-2 text-xs sm:text-sm font-semibold whitespace-nowrap border-b-2 -mb-px transition-colors ${
            isActive
              ? 'border-primary-600 text-primary-600'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
          }`
        }
      >
        <tab.icon className="w-4 h-4" />
        {tab.label}
      </NavLink>
    ))}
  </div>
);

export default LeadsTabs;